import { Doc } from './Doc';
import { SortTypes } from './Sort';
import { FilterParams } from './FilterParams';

export interface TitleStat {
  id?: number;
  title: string;
  unitId?: number;
  timesUsed: number;
  lastUsedDate: Date;
}

const DEFAULT_MAP_OPTION = { combineUnits: false };

export const TitleModel = {
  create(props: Partial<TitleStat>): TitleStat {
    if (!props.title || !props.title.trim()) {
      throw new Error('Title is empty');
    }

    if (props.unitId == null) {
      throw new Error('Unit ID is missing');
    }

    const id = props.id || 0;
    const value = props.title.trim();
    const unitId = +props.unitId;
    const timesUsed = props.timesUsed !== undefined ? props.timesUsed : 1;
    const lastUsedDate = props.lastUsedDate ? new Date(props.lastUsedDate) : new Date();

    return { id, title: value, unitId, timesUsed, lastUsedDate };
  },

  map(docs: Doc[], options: { combineUnits: boolean, filters?: FilterParams } = DEFAULT_MAP_OPTION): TitleStat[] {
    const sort = options && options.filters && options.filters.sort;

    const titles = docs.map(doc =>
      TitleModel.create({
        title: doc.title,
        unitId: options.combineUnits ? 0 : doc.owningUnit.id,
        lastUsedDate: doc.modifiedDate
      })
    );

    const distinctTitles = titles.reduce(
      (distinct, title) => {
        const existing = distinct.find(
          item => item.unitId === title.unitId && item.title.toUpperCase() === title.title.toUpperCase()
        );

        if (existing) {
          existing.timesUsed++;
          existing.lastUsedDate = existing.lastUsedDate > title.lastUsedDate ?
            existing.lastUsedDate :
            title.lastUsedDate;
        } else {
          distinct.push(title);
        }

        return distinct;
      },
      [] as TitleStat[]
    );

    return distinctTitles.sort((title1, title2) => {
      if (sort === SortTypes.title) {
        title1.title.localeCompare(title2.title);
      }

      return title2.lastUsedDate.getTime() - title1.lastUsedDate.getTime();
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/models/TitleStat.ts